
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';


@Injectable()

export class AuthemailGuard implements CanActivate {

    constructor(
        private auth: AuthService,
        public navCtrl: NavController
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return this.auth.isLogin().then(async (userLogin: any) => {
            console.log('User Auth ->', userLogin);
            if (userLogin) {
                if (!userLogin.emailVerified) {
                    return true;
                } else {
                    this.navCtrl?.navigateRoot('/perfil');
                    return false;
                }
            } else {
                this.navCtrl?.navigateRoot('/login');
                return false;
            }
        });

    }


}
